var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bottom-button"}},[_c('div',{class:['bottom-wrapper', _vm.className],style:({marginBottom:65+_vm.tabHeight +'px'}),attrs:{"id":"bottomBox"}},[_c('div',{staticClass:"bottom-btn",class:{ active: _vm.state, inactive: !_vm.state},attrs:{"id":"bottom-btn"},on:{"click":_vm.bottomClick}},[_vm._v(_vm._s(_vm.title)+"\r\n      ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70be4242","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom-button3.vue
// module id = null
// module chunks = 